// @ts-nocheck
import * as React from "react";
import {connect, Provider} from "react-redux";
import history from "../utils/history";
import {Redirect, Route, Router, Switch} from "react-router-dom";
import {PersistGate} from "redux-persist/integration/react";
import App from "../App";
import PrivateRoute from "./privateRoutes";
import Loading from "../Pages/Loading";
import {DOMAIN_ENV, DOMAIN_TYPE, getEnvironment} from "../constants";
import {setDcfWindow, setVersion, updateEnv} from "../ducks";
import {closeScreen} from "../utils/index";
import Page404 from "../Pages/page404";
import PageSession from "../Pages/pageSession";

const UserLogin = React.lazy(() => import("../Pages/userLogin"));
const SafeKeyAuthIframe = React.lazy(() => import("../Pages/safeKeyAuthIframe"));
const SafeKeyServices = React.lazy(() => import("../Pages/srcsafekeyservices"));
const ConfigurationSafeKeyAuth = React.lazy(() => import("../Pages/configurationSafeKeyAuth"));
const SelectCard = React.lazy(() => import("../Pages/selectCard"));
const OneTimePassword = React.lazy(() => import("../Pages/oneTimePassword"));
const ErrorScreen = React.lazy(() => import("../Pages/errorScreen"));
const Configuration = React.lazy(() => import("../Pages/configuration"));
const Checkout = React.lazy(() => import("../Pages/checkout"));
const SelectChannel = React.lazy(() => import("../Pages/selectChannel"));

declare global {
    interface Window {
        Jose: any;
        initApi: String;
        amexSession: any;
        initRequest: any;
        requestConfig: any;
        checkoutStart: boolean;
    }
}


window.amexSession = (() => {
    let store: any = {};
    return {
        getItem: (key: string) => {
            return store[key];
        },
        setItem: (key: string, value: any) => {
            store[key] = value.toString();
        },
        clear: () => {
            store = {};
        },
        removeItem: (key: string) => {
            delete store[key];
        },
        getAll: () => {
            return store;
        },
    };
})();

class Routes extends React.Component<any, {}> {
    receiveMessage = (e) => {
        try {
            if (e.data) {
                const parsedData: any = (e.data && typeof e.data === "string") ? JSON.parse(e.data) : null;
                if (parsedData) {
                    if (parsedData.event === "REDIRECT") {
                        history.push(parsedData.path, {some: parsedData.data});
                    } else if (parsedData.event === "VERSION_CONFIG_READY") {
                        if (!this.props.version) {
                            this.props.setVersion("0.9");
                        }
                    } else if (parsedData.event === "CHECKOUT_START") {
                        window.checkoutStart = true;
                    } else if (parsedData.error && parsedData.error.message) {
                        this.setState({errorMessage: parsedData.error.message});
                    }

                }
            }
        } catch (e) {

        }
    };

    componentDidMount() {
        const {setVersion, updateEnv} = this.props;
        updateEnv(getEnvironment(DOMAIN_TYPE, DOMAIN_ENV));
        // window.addEventListener("unload", closeScreen);
        window.addEventListener("message", this.receiveMessage);
        window.addEventListener("unload", this.cancelSRC);

    }

    cancelSRC() {
        if (window.location.href.includes("/src") && !window.checkoutStart) {
             closeScreen();
        }
    }
    componentWillUnmount() {
        window.removeEventListener("unload", closeScreen);
        window.removeEventListener("message", this.receiveMessage);
        window.removeEventListener("unload", this.cancelSRC);
    }

    public render() {
        const dpaTransactionOptions = this.props.initRequest.dpaTransactionOptions;
        const isEmbedded = this.props.version === "1.1" &&
        (dpaTransactionOptions?.customInputData?.checkoutType === "paymentSetting" ||
         dpaTransactionOptions?.customInputData?.checkoutType === "withinCheckout");

        return (
            <Provider store={this.props.store}>
                <PersistGate loading={null} persistor={this.props.persistor}>
                    <div className="main-container">
                        <Router history={history}>
                            <React.Suspense fallback={<Loading/>}>
                                <Switch>
                                    <Route exact={true} path="/" render={(props) => <App {...props}/>}/>
                                    <PrivateRoute path="/configuration" component={Configuration}/>
                                    <PrivateRoute path="/checkout" component={Checkout} validate={true}/>
                                    <PrivateRoute path="/configurationSafeKeyAuth" component={ConfigurationSafeKeyAuth} />
                                    <PrivateRoute path="/srcsafekeyservices" component={SafeKeyServices} validate={true} />
                                    <PrivateRoute path="/src/safekeyauth-iframe" component={SafeKeyAuthIframe} isEmbedded={isEmbedded} />
                                    <PrivateRoute path="/src/user-login" component={UserLogin} isEmbedded={isEmbedded} />
                                    <PrivateRoute path="/src/select-card" component={SelectCard}/>
                                    <PrivateRoute path="/src/select-channel" component={SelectChannel}/>
                                    <PrivateRoute path="/src/verify" component={OneTimePassword}/>
                                    <PrivateRoute path="/src/error" component={ErrorScreen}/>

                                    <Route path="/session" component={PageSession}/>
                                    <Route path="/404" component={Page404}/>
                                    <Redirect to="/404"/>
                                </Switch>
                            </React.Suspense>
                        </Router>
                    </div>
                    {/* <div tab-index='0' className="fixed-footer">*/}
                        {/* © 2022 American Express Company. All rights reserved.*/}
                    {/* </div>*/}
                </PersistGate>
            </Provider>
        );
    }
}

export default connect((src) => (src),
    (dispatch: any) => ({
        updateEnv: (name: string) =>
            dispatch(updateEnv(name)),
        setDcfWindow: (val: string) =>
            dispatch(setDcfWindow(val)),
        setVersion: (val: string) =>
            dispatch(setVersion(val)),
    }))(Routes);
